export const getVideoRoot = (state, props) => {
  // If we were passed a `videoId`, use that to look up the video root
  if (props.videoId) {
    const videoId = props.videoId;
    const videoRoot = state.story.entities.videos[videoId].src;
    return videoRoot;
  }

  throw new Error("no videoId defined");
};

export default getVideoRoot;
